import { computed, reactive } from 'vue'

const config = reactive({})

// Computed
const abConfig = computed(() => {
  return config
})

export default function useABConfig() {
  return {
    abConfig,
  }
}
